import { render, staticRenderFns } from "./ImageList.vue?vue&type=template&id=bdbd6270&scoped=true"
import script from "./ImageList.vue?vue&type=script&lang=js"
export * from "./ImageList.vue?vue&type=script&lang=js"
import style0 from "./ImageList.vue?vue&type=style&index=0&id=bdbd6270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd6270",
  null
  
)

export default component.exports